import { FeatureState } from '@outlaw/core';

export type Features = {
  [key in FeatureFlags]: FeatureState;
};

export enum FeatureFlags {
  paywall = 'paywall',
  newPlaylist = 'newPlaylist',
  communityInApp = 'communityInApp',
  comments = 'comments',
  paidPosts = 'paidPosts',
  openProfileInNewWindow = 'openProfileInNewWindow',
  showRecommendationMessage = 'showRecommendationMessage',
  showProfileLinksInRecommendedByDialog = 'showProfileLinksInRecommendedByDialog',
  showWidgets = 'showWidgets',
  showThemeToggle = 'showThemeToggle',
  selections = 'selections',
}
